module.exports = __webpack_public_path__ + "img/1-5.f503456f.png";